import { Sun } from "lucide-react";
import { T, useLang } from "@/lib/i18n";

export default function Marquee() {
  const { lang } = useLang();
  const items = T[lang].marquee;

  const row = (
    <div className="flex items-center shrink-0">
      {items.map((item) => (
        <span key={item} className="flex items-center">
          <span className="font-serif-display italic text-xl sm:text-2xl text-[#F5EBD2] px-8 whitespace-nowrap">{item}</span>
          <Sun className="w-5 h-5 shrink-0 text-[#F0C861] animate-spin [animation-duration:12s]" />
        </span>
      ))}
    </div>
  );

  return (
    <div data-testid="editorial-marquee" className="relative border-y border-[#C5A059]/45 bg-gradient-to-r from-[#8a6a1c] via-[#1f5a3c] to-[#833030] py-5 overflow-hidden">
      <div className="marquee-track" key={lang}>
        {row}
        {row}
      </div>
    </div>
  );
}
